import React from 'react';
import { motion } from 'framer-motion';
export function CaseOpportunity() {
  return <div className="flex h-full w-full flex-col items-center justify-center bg-[var(--bg)] px-[clamp(2rem,7vw,7rem)] text-center" data-id="element-130" data-mp="1606t2ebkexgp">
      <motion.p initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.45
    }} className="text-[clamp(0.68rem,0.95vw,0.88rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-131" data-mp="rzw1f92fleuh">
        06 / The opportunity for BI Australia
      </motion.p>
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1,
      duration: 0.6
    }} className="mt-[clamp(0.8rem,1.5vw,1.4rem)] max-w-5xl text-[clamp(1.8rem,3.6vw,3.4rem)] font-extrabold leading-[1.05] tracking-[-0.04em] text-[var(--fg)]" data-id="element-132" data-mp="n2vvcy5l0c3d">
        The HCPs who don’t receive sales calls don’t necessarily have to be unreachable.
      </motion.h2>
      <motion.p initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.35,
      duration: 0.5
    }} className="mt-[clamp(0.8rem,1.6vw,1.4rem)] max-w-3xl text-[clamp(0.9rem,1.35vw,1.3rem)] font-medium leading-snug text-[var(--muted)]" data-id="element-133" data-mp="4cw9ek51fd46">
        Snakker provides a scalable way to reach, engage and learn from non-called HCPs — without requiring additional field-force activity.
      </motion.p>
      <motion.p initial={{
      opacity: 0,
      scale: 0.94
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.65,
      duration: 0.6,
      ease: 'easeOut'
    }} className="mt-[clamp(1.6rem,4vw,3.5rem)] text-[clamp(2.8rem,8vw,7.5rem)] font-extrabold leading-none tracking-[-0.055em] text-[var(--brand)]" data-id="element-134" data-mp="3bizmlnrkmwd4">
        Non-target ≠ Non-engaged
      </motion.p>
    </div>;
}